import React from "react";
import { TFunction } from "react-i18next";

const getAccordionItems = (t: TFunction) => [
  {
    key: "1",
    label: t("pages.Diagnosticos.accordionFaq.q1Label"),
    children: t("pages.Diagnosticos.accordionFaq.q1Answer"),
  },
  {
    key: "2",
    label: t("pages.Diagnosticos.accordionFaq.q2Label"),
    children: (() => {
      const items = [
        t("pages.Diagnosticos.accordionFaq.q2Item1"),
        t("pages.Diagnosticos.accordionFaq.q2Item2"),
        t("pages.Diagnosticos.accordionFaq.q2Item3"),
        t("pages.Diagnosticos.accordionFaq.q2Item4"),
        t("pages.Diagnosticos.accordionFaq.q2Item5"),
        t("pages.Diagnosticos.accordionFaq.q2Item6"),
      ];
      return (
        <>
          <p>{t("pages.Diagnosticos.accordionFaq.q2Intro") as string}</p>
          <ul>
            {items.map((item, i) => (
              <li key={i}>{item as string}</li>
            ))}
          </ul>
          <p>{t("pages.Diagnosticos.accordionFaq.q2Outro") as string}</p>
        </>
      );
    })(),
  },
  {
    key: "3",
    label: t("pages.Diagnosticos.accordionFaq.q3Label"),
    children: (
      <>
        <p>{t("pages.Diagnosticos.accordionFaq.q3Para1") as string}</p>
        <p>{t("pages.Diagnosticos.accordionFaq.q3Para2") as string}</p>
        <p>{t("pages.Diagnosticos.accordionFaq.q3Para3") as string}</p>
      </>
    ),
  },
];

export default getAccordionItems;
